import React from 'react';
import { ClockIcon, CreditCardIcon, LockIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { useCountdown } from '../hooks/useCountdown';
import { offer } from '../data/offer';
export function FinalCta() {
  const {
    hours,
    minutes,
    seconds,
    expired
  } = useCountdown(23.75);
  return <section id="offer" aria-labelledby="offer-heading" className="bg-navy-950" data-id="element-48" data-mp="15ckjkv8vocby">
      <div className="mx-auto max-w-content px-4 py-20 sm:px-6 lg:py-28" style={{
      paddingTop: "30px",
      paddingBottom: "30px"
    }} data-id="element-49" data-mp="1jcd58c5js2d2">
        <div className="mx-auto max-w-3xl text-center" data-id="element-50" data-mp="1ebxvdukh5czu">
          <h2 id="offer-heading" className="font-display text-[2.15rem] font-extrabold leading-[1.03] tracking-tight text-white sm:text-5xl" data-id="element-51" data-mp="1t1wpnm8ws4a1">
            Ready to Stop Being Broke and Start Building Real Wealth?
          </h2>
          <p className="mt-5 text-lg text-white/70" data-id="element-52" data-mp="22462iirng9ql">
            Join {offer.studentCount} ambitious Bangladesh youth who are already
            transforming their lives.
          </p>

          <div className="mt-10 flex flex-wrap items-baseline justify-center gap-x-4 gap-y-2" data-id="element-53" data-mp="n6w5iupthia3">
            <span className="font-display text-5xl font-extrabold tabular-nums text-white" data-id="element-54" data-mp="s5gwe3j6iplv">
              {offer.priceToday}
            </span>
            <span className="text-xl text-white/40 line-through" data-id="element-55" data-mp="x64v7bdngaqn">
              {offer.priceTomorrow}
            </span>
            <span className="text-sm text-celeste-300" data-id="element-56" data-mp="16504iwbzq0y6">
              One payment · 6 volumes + 5 bonuses · lifetime access - 100% Secure Checkout - Instant Digital Download
            </span>
          </div>

          <div className="mt-8 flex flex-col items-center" data-id="element-57" data-mp="1fu052k6554eh">
            <CtaButton size="lg" href={offer.checkoutUrl} label={<>YES! I WANT THE ARGENTINE MINDSET 🏆 for only <span className="text-[1.35em] font-extrabold" data-id="element-59" data-mp="1kv7eennxmbn9">14</span> USD</>} sublabel={`Instant Access · 7-Day Guarantee · Join ${offer.studentCount} Students`} data-id="element-58" data-mp="1fwmcmjt17jwp" />
          </div>

          <div className="mx-auto mt-10 max-w-xl rounded-xl border border-white/10 bg-navy-900 px-6 py-5" style={{
          paddingTop: "0px",
          paddingBottom: "0px"
        }} data-id="element-60" data-mp="1tuay9tuxav2t">
            <p className="flex flex-wrap items-center justify-center gap-2 text-sm text-white/75" data-id="element-61" data-mp="3lx5hrraokavc">
              <ClockIcon className="h-4 w-4 text-sun" aria-hidden="true" data-id="element-62" data-mp="3j61b0e3s3c2" />
              {expired ? <span data-id="element-63" data-mp="3uvh5nlk5wuk3">
                  This special price expires{' '}
                  <span className="font-semibold text-white" data-id="element-64" data-mp="df9c0un0taam">today</span>
                </span> : <>
                  This special price expires in
                  <span className="font-display font-bold tabular-nums text-white" data-id="element-65" data-mp="8gg199z4bxe5">
                    {hours}:{minutes}:{seconds}
                  </span>
                </>}
            </p>
            <p className="mt-3 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs text-white/50" data-id="element-66" data-mp="ifdj5u21gso6">
              <span className="flex items-center gap-1.5" data-id="element-67" data-mp="2o9wr7hvtobmh">
                <CreditCardIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-68" data-mp="2k7a7k49b1x0d" />
                100% secure payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-69" data-mp="2a33giv54wh0o">
                <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-70" data-mp="2e45bgzs0q6wu" />
                Your data is protected
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}